import AdvertisementForm from './AdvertisementForm';

export default AdvertisementForm;
